import webApi from "./api"

export class TopPageService {
    searchRego(data) {
        return webApi.post('car-detail/rego-redbook-api', data)
    }
    getSystemConfig() {
        return webApi.get('system-configurations')
    }
}

const topPageService = new TopPageService()

export default topPageService
